import React from 'react';
import { View, Image } from 'react-native';
import { CommonStyles } from '../../styles';
import { useComponentTKey, i18nNS } from '../../i18n';
import { useTranslation } from 'react-i18next';
import BaseText from '../BaseText';
import RowView from '../RowView';
import Icon from '../Icon';
import Images from '../../constants/Images';
import { cardStyle, getStringRating } from '../resultCards/card.utils';
const InvoiceHotelReceiptCard = ({ item }) => {
  useTranslation(i18nNS.resultCards);
  const { tKey } = useComponentTKey('HotelCard');
  const { t } = useTranslation(i18nNS.resultCards);
  return (
    <View style={CommonStyles.pt5}>
      <BaseText>{item.HotelName}</BaseText>
      {/* <BaseText>{item?.RateDescription}</BaseText> */}
      <RowView>
        <BaseText>
          {t(tKey('CheckIn'))}: {item?.CheckInDateText}{' '}
        </BaseText>
        <Icon name="arrowRight" />
        <BaseText>
          {' '}
          {t(tKey('CheckOut'))}: {item?.CheckOutDateText}
        </BaseText>
      </RowView>
      <BaseText>
        {t(tKey('Room'))}: {item?.RateDescription}
      </BaseText>
      <BaseText>{item?.AddressLine1}</BaseText>
      {item?.ItineraryNumber && <BaseText>Pincode #: {item.ItineraryNumber}</BaseText>}
      <BaseText>
        {t(tKey('Confirmation'))}: {item?.HotelConfirmationNumber}
      </BaseText>
      <Image
        style={[cardStyle.rating, CommonStyles.mr2]}
        source={Images.rating[item.ClassLevel * 10 || getStringRating(item.StarRating)]}
      />
    </View>
  );
};

export default InvoiceHotelReceiptCard;
